export default "__VITE_ASSET__CHeeadFc__"